import styled from 'styled-components';

export const TagsText = styled.p<{ color: string }>`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: ${({ color }) => color};
  margin: 15px 0 0 0;
`;
